/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ParkingLocation {
    PARKING_LOT = 'PARKING_LOT',
    UNDERGROUND_PARKING = 'UNDERGROUND_PARKING',
    PARKING_GARAGE = 'PARKING_GARAGE',
}
